module.exports = new __parcel__URL__("38769_h.afce7593.jpg").toString();